module.exports = __webpack_public_path__ + "static/media/stats-mobile3.b6e123df.png";